import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, experience, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
          <img src={image.src2} alt={image.alt2} />
          <div className='experience'><span>{experience.year}</span> {experience.text}</div>
        </div>
        <div className="sub-image two">
          <img src={image.src3} alt={image.alt3} />
          <img src={image.src4} alt={image.alt4} />
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Key Features */}
        <div className="skills">
          {points.map((point) => (
            <div className="box" key={point.id}>
              <h3>
                {point.title}
                <span> {point.progress}% </span>
              </h3>
              <div className="progress-bar">
                <span style={{ width: `${point.progress}%` }}></span>
              </div>
            </div>
          ))}
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;